module.exports = __webpack_public_path__ + "img/90ne.d78e725d.svg";